export const NAVIGATION_ITEMS = [
    {
        key: 'home',
        label: 'Главная',
        path: '/',
    },
    {
        key: 'about',
        label: 'О компании',
        path: '/about',
    },
    {
        key: 'products',
        label: 'Продукция',
        path: '/products',
        children: [
            {
                key: 'enamels',
                label: 'Эмали',
                path: '/enamels',
            },
        ],
    },
    {
        key: 'contacts',
        label: 'Контакты',
        path: '/contacts',
    },
];
export const COMPANY_ADVANTAGES = [
    {
        id: 1,
        title: '15+ лет на рынке',
        description: 'Многолетний опыт и стабильность в строительной отрасли',
        icon: '🏗️',
    },
    {
        id: 2,
        title: 'Собственный логистический центр',
        description: '25,000 м² современных складских площадей в Новосибирске',
        icon: '🏭',
    },
    {
        id: 3,
        title: 'Сеть складов по Сибири',
        description: '8 складов в разных городах для быстрой доставки',
        icon: '🚚',
    },
    {
        id: 4,
        title: '50,000+ наименований',
        description: 'Полный ассортимент строительных и отделочных материалов',
        icon: '🔨',
    },
    {
        id: 5,
        title: 'Прямые поставки с заводов',
        description: 'Оптимальные цены без посредников и гарантия качества',
        icon: '⚡',
    },
    {
        id: 6,
        title: 'Современные технологии',
        description: 'CRM-система, онлайн-магазин и автоматизированная логистика',
        icon: '💎',
    },
];
export const CONTACT_INFO = {
    phone: '+7 (383) 362 17 17',
    email: '101@legarta.ru',
    address: 'Новосибирск, ул. Станционная, 60/1, к. 2/4',
    workingHours: 'Пн-Пт: 9:00-18:00',
    website: 'www.legarta.ru',
    founded: '2009',
    employees: '150+',
    turnover: '5+ млрд ₽',
};
